'use client';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const Portal = ({ children }) => {
  const [render, setRender] = useState(false);

  useEffect(() => {
    setRender(true);
  }, []);

  return render ? createPortal(children, document.body) : null;
};
